import { Component, OnInit, inject } from '@angular/core';
import { WHATSAPP } from '../../constants/whatsapp';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { LucideAngularModule, MailIcon } from 'lucide-angular';

@Component({
  selector: 'allas-entrega-domicilio',
  imports: [MainLayout, LucideAngularModule],
  template: `
    <allas-main-layout>
      <div class="min-h-screen bg-white">
        <!-- Header -->
        <header class="bg-white border-b"></header>

        <!-- Main Hero Section -->
        <section class="bg-gray-50 py-16">
          <div class="container mx-auto px-4">
            <div class="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h1 class="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                  COMPRA EN LÍNEA, ENTREGA EN TIENDA
                </h1>
                <div class="mb-8">
                  <p class="text-lg text-gray-600 mb-6">
                    Encuentra una de nuestras 12 sucursales que estén cerca de
                    ti.
                  </p>
                  <button
                    class="bg-[#df040b] hover:bg-[#c0030a] text-white px-8 py-3 text-lg font-semibold"
                  >
                    Encuentra tu Tienda
                  </button>
                </div>
              </div>
              <div class="h-96 flex items-center justify-center">
                <img
                  src="/servicios/entrega-domicilio/compra-en-linea-entrega-en-tienda.png"
                  alt="Cliente recogiendo pedido en tienda ALLAS REPUESTOS"
                  class="w-full h-full object-cover rounded-lg"
                />
              </div>
            </div>
          </div>
        </section>

        <!-- Immediate Delivery Section -->
        <section class="py-16">
          <div class="container mx-auto px-4">
            <div class="grid lg:grid-cols-2 gap-12 items-center">
              <div class="h-80 flex items-center justify-center">
                <img
                  src="/servicios/entrega-domicilio/entrega-inmediata.png"
                  alt="Repartidor de ALLAS REPUESTOS en motocicleta para entrega inmediata"
                  class="w-full h-full object-cover rounded-lg"
                />
              </div>
              <div>
                <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  ENTREGA INMEDIATA, PUERTA A PUERTA
                  <div class="w-16 h-1 bg-[#df040b] mt-2"></div>
                </h2>
                <p class="text-lg text-gray-600 mb-4">
                  Desde tu sucursal más cercana (misma ciudad) recibe tu pedido
                  entre 2 a 4 horas.
                </p>
                <p class="text-sm text-gray-500 mb-6">
                  *Costo por envío desde 75 lempiras.
                </p>
                <button
                  class="bg-[#df040b] hover:bg-[#c0030a] text-white px-8 py-3 text-lg font-semibold"
                >
                  Encuentra tu Tienda
                </button>
              </div>
            </div>
          </div>
        </section>

        <!-- Delivery Options Section -->
        <section class="bg-gray-50 py-16">
          <div class="container mx-auto px-4">
            <h2
              class="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center"
            >
              MÁS OPCIONES DE ENTREGA DISPONIBLES
            </h2>

            <!-- Top Two Options with Images -->
            <div class="grid lg:grid-cols-2 gap-8">
              <!-- Next Day Delivery Option -->
              <div
                class="bg-white rounded-lg shadow-md overflow-hidden border-2 border-transparent hover:border-[#df040b] transition-colors"
              >
                <div class="flex items-center">
                  <div class="w-1/4 h-24">
                    <img
                      src="/servicios/entrega-domicilio/compra-en-linea-entrega-en-tienda.png"
                      alt="Repartidor de ALLAS REPUESTOS entregando paquete al día siguiente"
                      class="w-full h-full object-cover"
                    />
                  </div>
                  <div class="w-3/4 p-4">
                    <h3 class="text-lg font-bold text-gray-800 mb-2">
                      ENTREGA AL DÍA SIGUIENTE
                    </h3>
                    <p class="text-gray-600 mb-1 text-sm">
                      Recibe gratis tus pedidos de cualquier sucursal de la
                      misma ciudad.
                    </p>
                    <p class="text-xs text-gray-500">
                      *Compra mínima: 1000 lempiras.
                    </p>
                  </div>
                </div>
              </div>

              <!-- National Shipping Option -->
              <div
                class="bg-white rounded-lg shadow-md overflow-hidden border-2 border-transparent hover:border-[#df040b] transition-colors"
              >
                <div class="flex items-center">
                  <div class="w-1/4 h-24">
                    <img
                      src="/servicios/entrega-domicilio/encomiendas.png"
                      alt="Envíos nacionales por encomienda ALLAS REPUESTOS"
                      class="w-full h-full object-cover"
                    />
                  </div>
                  <div class="w-3/4 p-4">
                    <h3 class="text-lg font-bold text-gray-800 mb-2">
                      ENVÍOS NACIONALES
                    </h3>
                    <p class="text-gray-600 mb-1 text-sm">
                      De 2 a 3 días hábiles por encomienda.
                    </p>
                    <p class="text-xs text-gray-500">
                      *Costo según peso y destino.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Popular Parts Section -->
        <section class="py-16">
          <div class="container mx-auto px-4">
            <h2
              class="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center"
            >
              REPUESTOS POPULARES PARA ENTREGA HOY MISMO
            </h2>

            <div class="grid grid-cols-2 md:grid-cols-5 gap-8">
              <div class="text-center">
                <div
                  class="rounded-lg p-4 h-32 flex items-center justify-center mb-4"
                >
                  <img
                    src="/servicios/entrega-domicilio/bujias.webp"
                    alt="Bujías Bosch"
                    class="w-full h-full object-contain"
                  />
                </div>
                <h3 class="font-bold text-gray-800">BUJÍAS</h3>
              </div>

              <div class="text-center">
                <div
                  class="rounded-lg p-4 h-32 flex items-center justify-center mb-4"
                >
                  <img
                    src="/servicios/entrega-domicilio/brake-pads.webp"
                    alt="Pastillas de freno"
                    class="w-full h-full object-contain"
                  />
                </div>
                <h3 class="font-bold text-gray-800">PASTILLAS Y DISCOS</h3>
              </div>

              <div class="text-center">
                <div
                  class="rounded-lg p-4 h-32 flex items-center justify-center mb-4"
                >
                  <img
                    src="/servicios/entrega-domicilio/alternator.webp"
                    alt="Alternador automotriz"
                    class="w-full h-full object-contain"
                  />
                </div>
                <h3 class="font-bold text-gray-800">ALTERNADORES</h3>
              </div>

              <div class="text-center">
                <div
                  class="rounded-lg p-4 h-32 flex items-center justify-center mb-4"
                >
                  <img
                    src="/servicios/entrega-domicilio/headlights.webp"
                    alt="Faros delanteros"
                    class="w-full h-full object-contain"
                  />
                </div>
                <h3 class="font-bold text-gray-800">FAROS</h3>
              </div>

              <div class="text-center">
                <div
                  class="rounded-lg p-4 h-32 flex items-center justify-center mb-4"
                >
                  <img
                    src="/servicios/entrega-domicilio/escobillas.webp"
                    alt="Escobillas limpiaparabrisas"
                    class="w-full h-full object-contain"
                  />
                </div>
                <h3 class="font-bold text-gray-800">ESCOBILLAS</h3>
              </div>
            </div>

            <div
              class="mt-12 text-center text-sm text-gray-600 max-w-4xl mx-auto"
            >
              <p>
                *Válido solo en mercados seleccionados. El envío gratis al
                siguiente día es para todos los pedidos que totalicen al menos
                L1,000 (excluyendo impuestos). Las compras de tarjetas de regalo
                y cargos básicos están excluidos. La Entrega al Día Siguiente se
                basa en el horario límite de pedidos diarios que varía según la
                ubicación, así como la disponibilidad del producto. Consulte los
                Términos y Condiciones de Entrega al Día Siguiente para obtener
                más detalles.
              </p>
            </div>
          </div>
        </section>

        <!-- Quick Contact Section -->
        <section class="bg-[#003f87] text-white py-12">
          <div class="container mx-auto px-4">
            <div class="grid md:grid-cols-2 gap-8 text-center">
              <div>
                <lucide-icon
                  [name]="mailIcon"
                  class="h-12 w-12 mx-auto mb-4 text-[#df040b]"
                />
                <h3 class="font-bold text-xl mb-2">Escribinos por WhatsApp</h3>
                <button
                  class="bg-green-600 hover:bg-green-700 text-white px-6 py-3 text-lg font-semibold mb-4"
                  (click)="openWhatsApp()"
                >
                  {{ whatsapp.display }}
                </button>
                <div class="flex flex-wrap justify-center gap-2">
                  <span
                    class="bg-white/20 text-white px-3 py-1 rounded-full text-sm"
                    >Lun - Vi: 8AM - 5PM</span
                  >
                  <span
                    class="bg-white/20 text-white px-3 py-1 rounded-full text-sm"
                    >Sab: 8AM - 3PM</span
                  >
                </div>
              </div>

              <div>
                <lucide-icon
                  [name]="mailIcon"
                  class="h-12 w-12 mx-auto mb-4 text-[#df040b]"
                />
                <h3 class="font-bold text-xl mb-2">Escribinos</h3>
                <button
                  class="bg-[#df040b] hover:bg-[#c0030a] text-white px-6 py-3 text-lg font-semibold mb-4"
                  (click)="openEmail()"
                >
                  ventas&#64;allasrepuestos.com
                </button>
                <div class="flex justify-center">
                  <span
                    class="bg-white/20 text-white px-3 py-1 rounded-full text-sm"
                    >Respuesta en 30 min</span
                  >
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </allas-main-layout>
  `,
})
export class EntregaDomicilio implements OnInit {
  readonly whatsapp = WHATSAPP;
  readonly mailIcon = MailIcon;

  private title = inject(Title);
  private meta = inject(Meta);

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle = 'Entrega a Domicilio | Allas Repuestos';
    const description =
      'Servicio de entrega a domicilio de repuestos automotrices en Honduras. Entrega inmediata, al día siguiente y envíos nacionales con garantía.';
    const keywords =
      'entrega a domicilio, repuestos automotrices, envío Honduras, Allas Repuestos, entrega inmediata, envío gratis, repuestos online';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }

  openWhatsApp() {
    window.open(this.whatsapp.url(), '_blank');
  }

  openEmail() {
    window.open('mailto:ventas@allasrepuestos.com', '_blank');
  }
}
